// src/components/SerSocio.js
import React, { useState } from "react";
import logo from "../assets/img/logoadutem.png";
import logoblanco from "../assets/img/logoADUTEMblanco.png";
import "../assets/css/styles.css";

const SerSocio = () => {
  const [seccion, setSeccion] = useState("req");

  return (
    <>
      {/* ================= NAVBAR ================= */}
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container">
          <a className="navbar-brand" href="/">
            <img src={logo} alt="Logo ADUTEM" height="90" className="logo-adutem" />
          </a>

          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMenu">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarMenu">
            <ul className="navbar-nav ms-auto align-items-center">
              <li className="nav-item me-lg-5"><a className="nav-link" href="/">Inicio</a></li>
              <li className="nav-item me-lg-5"><a className="nav-link" href="/nosotros">Nosotros</a></li>
              <li className="nav-item me-lg-5"><a className="nav-link" href="/convenios">Convenios</a></li>
              <li className="nav-item me-lg-5"><a className="nav-link" href="/eventos">Eventos</a></li>
              <li className="nav-item me-lg-5"><a className="nav-link" href="/login">Login</a></li>
            </ul>
          </div>
        </div>
      </nav>

      {/* ================= HERO SECTION ================= */}
  
      {/* ================= CONTENIDO PRINCIPAL ================= */}
      <section className="container py-5">
        <div className="text-center mb-5">
          <h2 className="fw-bold text-success">Cómo ser Socio de ADUTEM</h2>
          <p className="text-muted">Proceso simple y transparente para docentes de la UTM</p>
        </div>

        {/* Botones de navegación */}
        <div className="d-flex flex-wrap justify-content-center gap-3 mb-5">
          <button
            className={`btn ${seccion === "req" ? "btn-success" : "btn-outline-success"} px-5 py-3 fw-semibold rounded-3`}
            onClick={() => setSeccion("req")}
          >
            <i className="bi bi-list-check me-2"></i> Requisitos
          </button>

          

          <button
            className={`btn ${seccion === "ben" ? "btn-success" : "btn-outline-success"} px-5 py-3 fw-semibold rounded-3`}
            onClick={() => setSeccion("ben")}
          >
            <i className="bi bi-star-fill me-2"></i> Beneficios
          </button>
        </div>

        <div className="row g-5">
          {/* Contenido Principal */}
          <div className="col-lg-8">
            {seccion === "req" && (
              <>
                <h4 className="text-success fw-bold mb-4">Requisitos para ser Socio</h4>
                <div className="bg-light p-4 rounded-4">
                  <ul className="list-unstyled">
                    <li className="d-flex mb-3">
                      <span className="text-success fs-4 me-3">✓</span>
                      <span>Ser profesor con nombramiento de la Universidad Técnica de Manabí</span>
                    </li>
                    <li className="d-flex mb-3">
                      <span className="text-success fs-4 me-3">✓</span>
                      <span>Solicitar por escrito su deseo de ser socio de ADUTEM</span>
                    </li>
                    <li className="d-flex mb-3">
                      <span className="text-success fs-4 me-3">✓</span>
                      <span>Autorizar el descuento de la cuota mensual </span>
                    </li>
                  </ul>
                </div>

                <div className="mt-5">
                  <h5 className="fw-bold text-success">Documentos a presentar:</h5>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">• Solicitud de admisión</li>
              
                    <li className="list-group-item">• Copia de cédula de identidad</li>
                    
                    <li className="list-group-item">• Copia del nombramiento</li>
                    
                  </ul>
                </div>

                <div className="alert alert-success mt-4">
                  <strong>Nota:</strong> Enviar al correo adutem@utm.edu.ec
                </div>
              </>
            )}

            

            {seccion === "ben" && (
              <>
                <h4 className="text-success fw-bold mb-4">Beneficios de ser Socio</h4>
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body">
                        <h5>🤝 Convenios</h5>
                        <p className="text-muted">Descuentos exclusivos en comercios, servicios, educación, salud y otros establecimientos afiliados.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body">
                        <h5>🛡️Seguro de Vida</h5>
                        <p className="text-muted">Cobertura de vida para los socios, brindando protección y respaldo económico conforme a la póliza vigente.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body">
                        <h5>🎉 Eventos

</h5>
                        <p className="text-muted">Participación en actividades académicas, culturales, deportivas e institucionales organizadas por ADUTEM.</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body">
                        <h5>😷 Ayuda por enfermedad</h5>
                        <p className="text-muted">Apoyo económico para socios que atraviesan enfermedades graves, sujeto al cumplimiento de los requisitos establecidos por ADUTEM.</p>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </>
            )}
          </div>

          {/* Panel Lateral */}
          <div className="col-lg-4">
            <div className="card shadow border-0 sticky-top" style={{ top: "100px" }}>
              <div className="card-header bg-success-subtle text-success text-center fw-bold py-3">
  Documentos para Descargar
</div>
              <div className="card-body">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item d-flex justify-content-between align-items-center">
  <span>Solicitud de Admisión</span>
  <a
    href="https://docs.google.com/document/d/1SR6C6HbxlbvnInhr2JUo-5p9jR6iG6v3/edit?usp=sharing&ouid=105920105367146018538&rtpof=true&sd=true"
    target="_blank"
    rel="noopener noreferrer"
    className="btn btn-sm btn-outline-success"
  >
    Descargar
  </a>
</li>
                 <li className="list-group-item d-flex justify-content-between align-items-center">
  <span>Estatuto</span>
  <a
    href="https://drive.google.com/file/d/1WOptFIl3k1qqMD3RdIvfaIkfLQpeGYjS/view?usp=sharing"
    target="_blank"
    rel="noopener noreferrer"
    className="btn btn-sm btn-outline-success"
  >
    Descargar
  </a>
</li>
<li className="list-group-item d-flex justify-content-between align-items-center">
  <span>Información póliza de vida</span>
  <a
    href="https://segurosdelpichincha.com/documentos/certificado_informativo_adutem.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="btn btn-sm btn-outline-success"
  >
    Descargar
  </a>
</li>

<li className="list-group-item d-flex justify-content-between align-items-center">
  <span>Certificado Seguro ADUTEM</span>
  <a
    href="https://drive.google.com/file/d/1lx7Q11q42SAAYnMivZ3R0Jj8hBVHWJuM/view?usp=sharing"
    target="_blank"
    rel="noopener noreferrer"
    className="btn btn-sm btn-outline-success"
  >
    Descargar
  </a>
</li>

<li className="list-group-item d-flex justify-content-between align-items-center">
  <span>Requisitos para Ayuda por Enfermedad</span>
  <a
    href="https://drive.google.com/file/d/1X6nAxHqfCaYJdinRnjqwuYVG-WdRbZ-D/view?usp=sharing"
    target="_blank"
    rel="noopener noreferrer"
    className="btn btn-sm btn-outline-success"
  >
    Descargar
  </a>
</li>

<li className="list-group-item d-flex justify-content-between align-items-center">
  <span>Derechos Y Deberes como Socio ADUTEM</span>
  <a
    href="https://drive.google.com/file/d/1rbbTtSFeGixQuixwjRqNe0EJ7JSNasra/view?usp=sharing"
    target="_blank"
    rel="noopener noreferrer"
    className="btn btn-sm btn-outline-success"
  >
    Descargar
  </a>
</li>
                </ul>

                <div className="mt-4 text-center">
                  <p className="text-muted small mb-2">¿Dudas?</p>
                  <a href="mailto:adutem@utm.edu.ec" className="btn btn-success w-100">
                    Escribir al correo
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FOOTER ================= */}
      <footer className="bg-verde-oscuro text-white py-4">
        <div className="container">
          <div className="row align-items-center gy-4">

            {/* Logo y descripción */}
            <div className="col-lg-4 text-center text-lg-start">
              <img
                src={logoblanco}
                alt="Logo ADUTEM"
                height="60"
                className="me-3 mb-2"
              />
              <p className="mb-0 small opacity-80">
                Asociación de Docentes de la Universidad Técnica de Manabí
              </p>
            </div>

            {/* Dirección y Redes Sociales */}
            <div className="col-lg-4 text-center">
              <h6 className="fw-bold mb-2 small text-uppercase">Dirección</h6>
              <p className="mb-1 small opacity-90">
                <i className="bi bi-geo-alt me-2"></i>
                Calle: Chile y Los Amigos
              </p>
              <p className="mb-1 small opacity-90">
                <i className="bi bi-telephone me-2"></i>
                Teléfono: (05) 2632-200 / 0999162353
              </p>
              <p className="mb-3 small opacity-90">
                <i className="bi bi-envelope me-2"></i>
                adutem@utm.edu.ec
              </p>

              <h6 className="fw-bold mb-3 small text-uppercase">Redes Sociales</h6>
              <div className="d-flex justify-content-center gap-4">
                <a href="https://www.instagram.com/adutem2025?igsh=MWU2aXJhZnh1Zjhtag==" className="text-white fs-4 opacity-80"><i className="bi bi-instagram"></i></a>
                <a href="https://www.facebook.com/share/1EQhuaFzqH/?mibextid=wwXIfr" className="text-white fs-4 opacity-80"><i className="bi bi-facebook"></i></a>
                <a href="https://youtube.com/@adutem?si=dluaO2vDTwiUwyfh" className="text-white fs-4 opacity-80"><i className="bi bi-youtube"></i></a>
              </div>
            </div>

            <div className="col-lg-4"></div>
          </div>

          <div className="text-center mt-3 pt-3 border-top border-secondary border-opacity-50">
            <small className="opacity-70">
              ADUTEM 2022 - 2025 © Todos los derechos reservados
            </small>
          </div>
        </div>
      </footer>
    </>
  );
};

export default SerSocio;